module.exports = __webpack_public_path__ + "img/english-construction-catalog.56040e52.webp";